export const selectAllCollections = (state) => state.collection.collections;
export const selectAllCollectionsStatus = (state) => state.collection.status;
export const selectAllCollectionsError = (state) => state.collection.error;
export const fullCollectionsList = (state) => state.collection.originalCollections;

export const selectCollectionsByCompany = (state) => state.collection.collectionsByCompany;

export const addCollectionStatus = (state) => state.collection.addCollectionStatus;
export const addCollectionError = (state) => state.collection.addCollectionError;

export const editCollectionStatus = (state) => state.collection.editCollectionStatus;
export const editCollectionError = (state) => state.collection.editCollectionError;

export const selectedCollectionDetails = (state) => state.collection.collectionDetails;

export const selectedCollectionID = (state) => state.collection.selectedCollectionID;

// drives selectors
export const selectCollectionDrives = (state) => state.collection.collectionDrives;
export const selectCollectionDrivesStatus = (state) => state.collection.getCollectionDrivesStatus;
export const selectCollectionDrivesError = (state) => state.collection.getCollectionDrivesError;

export const addDriveStatusSelector = (state) => state.collection.addDriveStatus;
export const addDriveErrorSelector = (state) => state.collection.addDriveError;

export const removeDriveStatusSelector = (state) => state.collection.removeDriveStatus;
export const removeDriveErrorSelector = (state) => state.collection.removeDriveError;

export const datasetID = (state) => state.collection.datasetID;
export const boundaries = (state) => state.collection.boundaries;
